//TODO : Refactor after ai
/** Auswahlliste im Stil der Beyond-UI-Felder (Label, Pflichtmarke, Fehler). */

interface Option {
  value: string;
  label: string;
}

interface AuswahlfeldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  optionen: Option[];
  required?: boolean;
  error?: string;
  multiple?: false;
}

export function Auswahlfeld({
  label,
  value,
  onChange,
  optionen,
  required,
  error,
}: AuswahlfeldProps) {
  const id = `auswahl-${label.replace(/\W+/g, "-").toLowerCase()}`;
  return (
    <div className="bui-field">
      <label className="bui-label" htmlFor={id}>
        {label}
        {required && <span className="bui-label__req">*</span>}
      </label>
      <div
        className="bui-input"
        data-size="md"
        data-error={Boolean(error) || undefined}
      >
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            flex: 1,
            minWidth: 0,
            border: 0,
            outline: "none",
            background: "transparent",
            font: "inherit",
          }}
        >
          {optionen.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
      {error && <span className="bui-field__error">{error}</span>}
    </div>
  );
}
